import { useDeviceClass } from '../../lib/device'
import { useInhabitSession } from './useInhabitSession'
import InhabitDesktop from './Desktop'

/**
 * The Inhabit surface.
 *
 * THE DEVICE SEAM, named and not yet built — the branch lives here, and today
 * every device class resolves to the same surface.
 *
 * This is the grammar most likely to need a real phone surface first: the will
 * line invites a composed sentence, and composing prose with a thumb is exactly
 * the act the input spine (tap › voice › type) exists to avoid. When that
 * surface is written, the hook does not move.
 */
export default function Inhabit({ packId, agreedPriceMicros }: {
  packId?: string
  /**
   * ⚠ THE PRICE THE PLAYER AGREED TO, in micros (2026-08-27 — the wallet). Carried from the
   * threshold card straight to `startSession`, where the server checks it against today's plan
   * and refuses a mismatch rather than charging the new price. Never recomputed on the way down:
   * this is a promise the player made about a specific number.
   *
   * Undefined = no price applied (an unpriced pack, or a build with no wallet).
   */
  agreedPriceMicros?: number
}) {
  const device = useDeviceClass()
  // The pack may come from the door chooser rather than the route, so it is
  // passed in; the hook falls back to the route param when it is not.
  const session = useInhabitSession(packId, agreedPriceMicros)

  switch (device) {
    case 'mobile':
    case 'tablet':
    case 'desktop':
    default:
      return <InhabitDesktop session={session} />
  }
}
